import { render, staticRenderFns } from "./riskInformation-free.vue?vue&type=template&id=c7131900&"
import script from "./riskInformation-free.vue?vue&type=script&lang=js&"
export * from "./riskInformation-free.vue?vue&type=script&lang=js&"
import style0 from "./riskInformation-free.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports